import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { 
    Breadcrumbs,
    Link,
    Typography,
    Box
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';

const styles = theme => ({
    breadcrumbContainer: {
        padding: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        zIndex: 10,
        minHeight: '56px',
        display: 'flex',
        alignItems: 'center',
    },
    breadcrumbLink: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.primary.main,
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    breadcrumbIcon: {
        marginRight: theme.spacing(0.5),
        fontSize: '1.2rem',
    },
    breadcrumbCurrent: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
});

const routeLabels = {
    '/dashboard': 'Dashboard',
    '/meu-negocio': 'Meu Negócio',
    '/produtos': 'Produtos',
    '/produtos/cadastrar-produto': 'Cadastrar Produto',
    '/produtos/editar-produto': 'Editar Produto',
    '/produtos/imagens-do-produto': 'Imagens do Produto',
    '/produtos/video-do-produto': 'Vídeo do Produto',
    '/vendas-em-andamento': 'Vendas em Andamento',
    '/vendas-entregues': 'Vendas Entregues',
    '/vendas-canceladas': 'Vendas Canceladas',
    '/detalhar-venda': 'Detalhes da Venda',
    '/funcionarios-da-loja': 'Funcionários',
    '/funcionarios-da-loja/cadastrar-funcionario': 'Cadastrar Funcionário',
    '/funcionarios-da-loja/editar-funcionario': 'Editar Funcionário',
    '/categorias': 'Categorias',
    '/categorias/cadastrar-categoria': 'Cadastrar Categoria',
    '/categorias/editar-categoria': 'Editar Categoria',
    '/configuracoes': 'Configurações',
    '/perguntas-e-respostas': 'Perguntas e Respostas',
    '/re-stripe-onboarding': 'Integração Stripe',
    '/lojas': 'Lojas',
    '/lojas/cadastrar-loja': 'Cadastrar Loja',
    '/lojas/editar-loja': 'Editar Loja',
    '/lojas/logo-da-loja': 'Logo da Loja',
    '/funcionarios': 'Funcionários (Admin)',
    '/usuarios': 'Usuários (Admin)',
    '/vendas': 'Vendas (Admin)',
    '/campanhas-publicitarias-no-app': 'Campanhas Publicitárias',
    '/campanhas-publicitarias-no-app/cadastrar-campanha': 'Cadastrar Campanha Publicitária',
    '/campanhas-publicitarias-no-app/editar-campanha': 'Editar Campanha Publicitária',
    '/campanhas-publicitarias-no-app/visualizar-campanha': 'Visualizar Campanha Publicitária',
    '/versoes-app': 'Versões do App',
    '/versoes-app/cadastrar-versao': 'Cadastrar Versão',
    '/versoes-app/editar-versao': 'Editar Versão',
    '/cupom-de-desconto': 'Cupons de Desconto',
    '/cupom-de-desconto/cadastrar-cupom': 'Cadastrar Cupom',
    '/cupom-de-desconto/editar-cupom': 'Editar Cupom',
    '/cupom-de-desconto/detalhar-cupom': 'Detalhar Cupom',
    '/enderecos/:origem/:idOrigem': 'Endereços',
    '/enderecos/cadastrar-endereco/:origem/:idOrigem': 'Cadastrar Endereço',
    '/enderecos/editar-endereco/:origem/:idOrigem/:idEndereco': 'Editar Endereço',
    '/repasses-ao-vendedor': 'Repasses',
    '/repasses-ao-vendedor/detalhar-repasse': 'Detalhes do Repasse',
    '/notificacoes-push': 'Notificações Push',
    '/notificacoes-push/cadastrar-notificacao': 'Cadastrar Notificação Push',
    '/notificacoes-push/detalhar-notificacao': 'Detalhar Notificação Push',
    '/melhor-envio': 'Melhor Envio',
    '/melhor-envio/detalhar-frete': 'Detalhes do Frete',
    '/melhor-envio/gerar-etiqueta': 'Gerar Etiqueta',
};

const BreadcrumbNavigation = ({ classes }) => {
    const location = useLocation();
    const paths = location.pathname.split('/').filter(p => p);
    
    const breadcrumbs = [
        { label: 'Home', path: '/dashboard', icon: true }
    ];
    
    let currentPath = '';
    paths.forEach((path, index) => {
        currentPath += `/${path}`;
        const label = routeLabels[currentPath] || path;
        breadcrumbs.push({
            label,
            path: currentPath,
            isLast: index === paths.length - 1
        });
    });

    return (
        <Box className={classes.breadcrumbContainer}>
            <Breadcrumbs maxItems={3} aria-label="breadcrumb">
                {breadcrumbs.map((breadcrumb, index) => (
                    breadcrumb.isLast ? (
                        <Typography 
                            key={index}
                            className={classes.breadcrumbCurrent}
                        >
                            {breadcrumb.icon && (
                                <HomeIcon className={classes.breadcrumbIcon} />
                            )}
                            {breadcrumb.label}
                        </Typography>
                    ) : (
                        <Link
                            key={index}
                            component={RouterLink}
                            to={breadcrumb.path}
                            className={classes.breadcrumbLink}
                        >
                            {breadcrumb.icon && (
                                <HomeIcon className={classes.breadcrumbIcon} />
                            )}
                            {breadcrumb.label}
                        </Link>
                    )
                ))}
            </Breadcrumbs>
        </Box>
    );
};

export default withStyles(styles)(BreadcrumbNavigation);